import { Typography, colors, Stack, getRecipeColor, useModal } from '@ui-components/neo.tax';
import React from 'react';

import { type AscProject, type AscProjectTeamMember } from '@neo.tax/asc/hooks';
import { HIGHLIGHT_VARIANT } from '@neo.tax/shared';

import { EditContributorAllocationModalLoader } from '../contributor-allocation-modal';
import { Percentage } from './asc-project-team-members';

interface AscTeamMemberAllocationProps {
  ascProject: AscProject;
  ascProjectTeamMember: AscProjectTeamMember;
}

export const AscTeamMemberAllocation = ({
  ascProject,
  ascProjectTeamMember,
}: AscTeamMemberAllocationProps): React.ReactElement => {
  const { isOpen, toggle } = useModal();

  return (
    <>
      <Stack direction="row" justifyContent="end" space={1} fullWidth>
        <Percentage onClick={toggle} fontSize="sm" color={getRecipeColor(HIGHLIGHT_VARIANT, 'whiteBg').text}>
          {ascProjectTeamMember.allocationPercent}
        </Percentage>
        <Typography fontSize="sm" color={colors.gray[500]}>
          %
        </Typography>
      </Stack>
      <EditContributorAllocationModalLoader
        isOpen={isOpen}
        close={toggle}
        contributorId={ascProjectTeamMember.contributorId}
        selectedAscProject={ascProject}
      />
    </>
  );
};
